<template>
    <div  :style="{
            backgroundColor: backgroundColor,
            zIndex: 1000
        }"
        v-if="useageNotesOpen"
        class="ctw-absolute ctw-right-0 ctw-left-0 ctw-top-0 ctw-bottom-0 md:ctw-h-full ctw-rounded-xl" >
        <div class="ctw-flex ctw-justify-end">

        </div>
        <div class="ctw-border ctw-border-1 ctw-border-white ctw-text-white ctw-h-full ctw-flex ctw-flex-col">
            <div class="ctw-pt-6 ctw-px-6">
                <span class="ctw-font-bold">
                {{disclaimerTitle}}
                </span>
            </div>
            <div class="ctw-h-full ctw-overflow-y-scroll ctw-mt-6 ctw-px-6">
                <span class="ctw-text-white72 ctw-text-xs" v-html="disclaimerText">
                </span>
            </div>
            <div class=" ctw-px-6 ctw-pb-6">
                <button @click="toggleUsageNotes" class="ctw-w-full ctw-mt-8 ctw-bg-blue-400 ctw-text-blue-800 ctw-border ctw-border-blue-900 ctw-border-1 ctw-font-medium ctw-rounded ctw-mt-4 ctw-px-4 ctw-py-2 hover:ctw-bg-blue-600 hover:ctw-text-white">
                    Schließen
                </button>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { useWidgetStore } from '@/store/widget';

const widgetStore = useWidgetStore();


const backgroundColor = widgetStore.backgroundColor;
const useageNotesOpen = computed(() => widgetStore.disclaimerOpened);
const toggleUsageNotes = () => {
    widgetStore.toggleDisclaimer();
}

const disclaimerTitle = computed(() => widgetStore.bot.disclaimer.title || 'Nutzungsbedingungen');
const disclaimerText = computed(() => widgetStore.bot.disclaimer.text || 'Alle angaben des Bots sind unverbindlich und auf eigene Verantwortung.');

</script>